import { Injectable } from '@angular/core';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { Subscription } from 'rxjs';
import { sentryConfig } from './sentry-config';

@Injectable({ providedIn: 'root' })
export class ExpiredTokenHandler {
  private loginErrorsNeedingRedirect: RegExp[] = sentryConfig.ignoreErrors;

  private subscription: Subscription;
  constructor(private broadcastService: BroadcastService, private msalService: MsalService) {
    this.subscription = null;
  }

  initialize() {
    if (this.subscription === null) {
      this.subscription = this.broadcastService.subscribe('msal:acquireTokenFailure', payload => {
        // https://github.com/AzureAD/azure-activedirectory-library-for-js/issues/456
        // local storage token expires, need to relogin
        if (payload) {
          if (this.loginErrorsNeedingRedirect.some(t => t.test(payload.toString()))) {
            this.msalService.loginRedirect();
          }
        }
      });
    }
  }
  release() {
    if (this.subscription !== null) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }
}
